$(function(){
    /*console.log("tjenna2");
    $(".player-league-select").select2({
        placeholder: 'Välj liga',
        templateResult: formatLeaguePlayer
    });
    $(".player-team-select").select2({
        placeholder: 'Väj lag',
        templateResult: formatTeamPlayer
    });*/

    $(".player-league-select").change(function(){
        //$("#merchandise").css("opacity", "0.2");
        //$("#merchandise-spinner").show();
        $(".player-team-select").html("<option></option>").trigger("change").prop("disabled", true);
        $(".player-league-select > option").each(function(){
            if($(this).is(":selected")){
                var league_id = $(this).data("league-id");
                $.get(
                    ajaxUrl+"/ajax/getPlayerTeams.php",
                    {
                        league_id : league_id
                    },
                    function(data){
                        var result = $.parseJSON(data);
                        if(result.success == true){
                            $(".player-team-select").append(result.teams).trigger("change").prop('disabled', false).focus();
                            //$("#merchandise").html(result.merchandise);
                            //$("#merchandise-spinner").hide();
                            //$("#merchandise").css("opacity", "1");
                        }
                    }
                );
            }
        });
    });

    $(".player-team-select").change(function(){
        $(".merchandise-team-select > option").each(function(){
            if($(this).is(":selected")){
                var team_id = $(this).data("team-id");
                $.get(
                    ajaxUrl+"/ajax/getMerchandiseByTeamId.php",
                    {
                        team_id : team_id
                    },
                    function(data){
                        var result = $.parseJSON(data);
                        if(result.success == true){
                            $("#merchandise").html(result.data);
                        }
                    }
                );
            }
        });
    });

});
function formatLeaguePlayer (state) {
    if (state.element && state.element.dataset) {
        logo = state.element.dataset.leagueLogo;
    } else {
        logo = "";
    }
    if (!state.id) {
        return state.text;
    }
    var baseUrl = "//images.fotboll.com";
    var $state = $(
        '<span><img src="' + baseUrl + '/' + logo + '" class="img-select-player" /> ' + state.text + '</span>'
    );
    return $state;
}
function formatTeamPlayer (state) {
    if (!state.id) {
        return state.text;
    }
    var baseUrl = "//images.fotboll.com";
    var $state = $(
        '<span><img src="' + baseUrl + '/' + state.element.value + '" class="img-select-team-player" /> ' + state.text + '</span>'
    );
    return $state;
}